module.exports = __webpack_public_path__ + "img/logo.e695c67a.png";